const sliderElement = document.querySelector('.js-service-ceremony-slider');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (sliderElement && typeof Swiper !== 'undefined') {
  new Swiper(sliderElement, {
    loop: true,
    autoplay: false,
    speed: reduceMotion ? 0 : 500,
    navigation: {
      prevEl: '.service-ceremony__slider-button.-prev',
      nextEl: '.service-ceremony__slider-button.-next',
    },
    pagination: {
      el: '.service-ceremony__pagination',
      clickable: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: '前の画像を表示',
      nextSlideMessage: '次の画像を表示',
      paginationBulletMessage: '{{index}}枚目の画像を表示',
    },
  });
}
